import { VWO_EXPERIMENT_NAME } from 'gatsby-env-variables'

import { useState, useEffect, useCallback } from 'react'

import { useLead, useProposal, useRecaptcha } from '@itau-loans-www/hooks'
import { http } from '@itau-loans-www/services'
import { goTo, cleanWhitespaces, getVwoData } from '@itau-loans-www/utils'

const useBasicData = () => {
  const { setIsLoading, cleanProduct } = useProposal()
  const [isButtonLoading, setButtonLoading] = useState(false)

  const { getRecaptcha } = useRecaptcha(setIsLoading, setButtonLoading)

  const {
    changeOffers,
    leadData: { partner },
    changeLeadData
  } = useLead()

  const cleanOlderProposalData = useCallback(() => {
    http.cleanAuth()
    cleanProduct()
    changeOffers({
      hero: undefined,
      others: undefined,
      desiredLoanValue: undefined
    })
    changeLeadData({ tracking: undefined })
  }, [changeLeadData, changeOffers, cleanProduct])

  useEffect(() => {
    cleanOlderProposalData()
  }, [cleanOlderProposalData])

  const onSubmit = async ({ name, email, cpf, phone }) => {
    let nextStepResponse = ''

    setButtonLoading(true)

    const recaptcha = await getRecaptcha()

    setIsLoading(true)

    const cleanedName = cleanWhitespaces(name)

    const formData = {
      cpf,
      name: cleanedName,
      email,
      phone,
      recaptcha: recaptcha ?? '',
      partner,
      vwo: getVwoData({ name: VWO_EXPERIMENT_NAME })
    }

    console.log({ formData });

    http.proposal
      .newCreateLead(formData)
      .then(async ({ next_step }) => {
        changeLeadData({
          name,
          email,
          cpf,
          phone
        })

        nextStepResponse = next_step
      })
      .catch((err) => {
        console.log({ err })
        setIsLoading(false)
        setButtonLoading(false)
      })
      .finally(() => {
        // Evitar que o erro "Converting circular structure to JSON" impacte o usuário
        if (nextStepResponse) {
          goTo(nextStepResponse)
        }
      })
  }

  // TO DO: testar handles de erro com os cenários:
  // - ocultar o recaptcha
  // - colocar o cleanWhitespaces como export default

  return {
    onSubmit,
    isButtonLoading
  }
}

export default useBasicData
